module.exports = __webpack_public_path__ + "img/telhado-colonial.a99853cb.jpg";